// src/Redux/pestTypesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPestTypes as fetchPestTypesAPI } from './api';

export const fetchPestTypes = createAsyncThunk(
  'pestTypes/fetchPestTypes',
  async (_, { getState }) => {
    const { pestTypes } = getState();
    if (pestTypes.items.length > 0) {
      // Already cached
      return pestTypes.items;
    }
    const response = await fetchPestTypesAPI();
    return response;
  }
);

const pestTypesSlice = createSlice({
  name: 'pestTypes',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPestTypes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPestTypes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchPestTypes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default pestTypesSlice.reducer;
